import * as types from "./../types";

const initState = {
  screenFlow : 'kycAddress', 
};

const ResiAddressReducer = (state = initState, action) => {
  switch (action.type) {
    case types.SAVE_RESIADD_FLAGS:
      return {
        ...state,
        screenFlow: action.payload?.screenFlow,      
      };
    default:
      return state;
  }
};

export default ResiAddressReducer;
